import Box from "@/common/components/Box";
import NegotiatingProductItemShow from "./NegotiatingProductItem";
import { NegotiationData, NegotiationProductData } from "../../types/negotiations.type";
import { EstablishmentCompanyData } from "@/features/company/types/company.type";

interface NegotiatingProductsShowProps {
  negotiationStatus: NegotiationData['status'];
  negotiationProducts?: NegotiationProductData[];
  establishment?: EstablishmentCompanyData;
}

const NegotiatingProductsShow = ({ negotiationStatus, negotiationProducts, establishment }: NegotiatingProductsShowProps) => {
  return (
    <Box className="flex flex-col gap-4">
      <p>Produtos em negociação</p>

      {negotiationProducts?.map((negotiationProduct, index) => (
        <NegotiatingProductItemShow
          key={negotiationProduct.id}
          index={index}
          negotiationStatus={negotiationStatus}
          negotiationProduct={negotiationProduct}
          establishment={establishment}
        />
      ))}
    </Box>
  );
};

export default NegotiatingProductsShow;
